import { render } from "./Masonry.vue?vue&type=template&id=565e60b5"
import script from "./Masonry.vue?vue&type=script&lang=js"
export * from "./Masonry.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__